export enum DashboardSavedViewsWidgetBlock {
  Root = 'DashboardSavedViewsWidget',
}
